import { useState, useEffect } from "react";
import {
  Flex,
  Text,
  FormControl,
  RadioGroup,
  Stack,
  FormErrorMessage,
  CheckboxGroup,
  Checkbox,
  FormLabel,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../components/RadioButtonField";
import CustomDropzone from "../../components/CustomDropzone";
import { CustomSelectWField } from "../../components/CustomSelectWField";
import CriancaService from "../../../main/services/CriancaService";
import Swal from "sweetalert2";

export default function ChangeRadio({
  setFieldValue,
  values,
  fieldName,
  fieldNameAnexo,
  label,
  labelAnexo,
  fieldNameCheck,
  idCrianca,
  setAnexo,
  irmaosData,
  irmaosDataBoolean,
  handleScrollToBottom,
  editar,
}) {
  const [tipoSentenca, setTipoSentenca] = useState({
    options: [],
    isLoading: false,
  });

  const handleCheckboxChange = (checkedValues, form) => {
    const updatedValues = form.values[fieldNameCheck].map((value) => ({
      ...value,
      compartilhado: checkedValues.includes(value.id) ? "S" : "N",
    }));

    form.setFieldValue(fieldNameCheck, updatedValues);
  };

  const handleCheckboxChangeCadastrar = (checkedValues) => {
    setFieldValue(fieldNameCheck, checkedValues);
  };

  const handleGetTipoSentenca = () => {
    setTipoSentenca({ ...tipoSentenca, isLoading: true });
    CriancaService.tipoSentenca().then((res) => {
      setTipoSentenca({ options: res.data, isLoading: false });
    });
  };

  const toggleCheckbox = (id, index, form) => {
    const updatedValues = form.values[fieldNameCheck].map((value, idx) => ({
      ...value,
      compartilhado:
        idx === index && value.id === id
          ? value.compartilhado === "S"
            ? "N"
            : "S"
          : value.compartilhado,
    }));

    form.setFieldValue(fieldNameCheck, updatedValues);
  };
  const [scrollLoading, setScrollLoading] = useState(false);

  useEffect(() => {
    if (scrollLoading && handleScrollToBottom) {
      handleScrollToBottom();
    }
  }, [scrollLoading, handleScrollToBottom]);

  return (
    <Flex
      flexDirection="column"
      gap={2}
      border="1px solid #b3b3b3"
      rounded="xl"
      px={2}
      py={3}
    >
      {fieldName === "compartilharProcesso" ? (
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
          htmlFor={label}
        >
          {label && typeof label === "string" ? label.toUpperCase() : label}
        </Text>
      ) : (
        <Text
          color="#5F6377"
          fontWeight="500"
          height={{ lg: "20px" }}
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={label}
        >
          {label}
        </Text>
      )}

      <Field name={fieldName} border="solid">
        {({ field, form }) => (
          <FormControl
            isInvalid={form.errors[fieldName] && form.touched[fieldName]}
            id={fieldName}
            width="max-content"
          >
            <RadioGroup value={field.value}>
              <Stack direction="row" gap={4}>
                <RadioButtonField
                  fieldName={fieldName}
                  value="S"
                  label="Sim"
                  loadingScroll={true}
                  setScrollLoading={setScrollLoading}
                />
                <RadioButtonField
                  fieldName={fieldName}
                  value="N"
                  label="Não"
                  loadingScroll={true}
                  setScrollLoading={setScrollLoading}
                  {...(fieldName === "compartilharProcesso" &&
                    editar && {
                      onBeforeChange: async (newValue, oldValue) => {
                        if (oldValue === "S" && newValue === "N") {
                          const result = await Swal.fire({
                            title: "Atenção!",
                            text: "Caso o processo/procedimento seja descompartilhado, as informações serão excluídas somente da ficha descompartilhada.",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#169499",
                            cancelButtonColor: "#169499",
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                          });
                          return result.isConfirmed;
                        }
                        return true;
                      },
                    })}
                />

                {fieldName !== "compartilharProcesso" && (
                  <RadioButtonField
                    fieldName={fieldName}
                    value={fieldName === "recurso" ? "I" : "A"}
                    label={
                      fieldName === "recurso"
                        ? "Sem Informação"
                        : fieldName === "extincaoPoderFamilia"
                        ? "Aguardando Prazo"
                        : "Não se Aplica"
                    }
                  />
                )}
              </Stack>
              <FormErrorMessage mt="1" mr="-14">
                {form.errors[fieldName]}
              </FormErrorMessage>
            </RadioGroup>

            {form?.values[fieldName] === "S" && fieldName === "sentenca" && (
              <Flex mt={4}>
                <CustomSelectWField
                  fieldName="idTipoSentenca"
                  label="Tipo*"
                  placeholder="Selecione o Tipo"
                  getOptionLabel={(option) => option?.descricao}
                  getOptionValue={(option) => option.id}
                  isLoading={tipoSentenca.isLoading}
                  options={tipoSentenca.options}
                  onChange={(value) => {
                    form.setFieldValue("idTipoSentenca", value);
                  }}
                  onFocus={() => handleGetTipoSentenca()}
                />
              </Flex>
            )}
            {form?.values[fieldName] === "S" && fieldNameAnexo && (
              <Flex mt={4}>
                <CustomDropzone
                  whiteSpace={true}
                  formProps={{ setFieldValue }}
                  title={labelAnexo}
                  fieldName={fieldNameAnexo}
                  height="42px"
                  titleText={labelAnexo}
                  setAnexoNaoEditado={() => {
                    setAnexo(true);
                  }}
                />
              </Flex>
            )}

            {form?.values[fieldName] === "S" &&
              fieldName === "compartilharProcesso" && (
                <CheckboxGroup
                  colorScheme="blue"
                  defaultValue={[""]}
                  value={
                    !irmaosDataBoolean
                      ? form?.values[fieldNameCheck]
                          .filter((irmao) => irmao.compartilhado === "S")
                          .map((irmao) => irmao.id)
                      : values[fieldNameCheck]
                  }
                  onChange={(checkedValues) =>
                    irmaosDataBoolean
                      ? handleCheckboxChangeCadastrar(checkedValues)
                      : handleCheckboxChange(checkedValues, form)
                  }
                >
                  <FormLabel
                    color="#5F6377"
                    fontWeight="500"
                    fontSize="14px"
                    lineHeight="19.6px"
                    mt={4}
                    htmlFor={fieldNameCheck}
                  >
                    {"Irmão*"}
                  </FormLabel>

                  <Text color="red" opacity={0.8} fontSize="12px">
                    {form?.errors[fieldNameCheck]}
                  </Text>
                  <Stack
                    width="full"
                    maxWidth={{ base: "340px", md: "400px", xl: "500px" }}
                    minWidth={{ base: "340px", md: "400px", xl: "500px" }}
                    mt={2}
                    direction="column"
                  >
                    {irmaosDataBoolean ? (
                      <>
                        {irmaosData?.options?.map((value, index) => (
                          <Checkbox
                            key={index}
                            border="1px solid #b3b3b3"
                            value={JSON.stringify(value)}
                            p={4}
                            name={fieldNameCheck}
                          >
                            {value.nomeIrmao}
                          </Checkbox>
                        ))}
                      </>
                    ) : (
                      <>
                        {form?.values[fieldNameCheck].map((value, index) => (
                          <Checkbox
                            key={index}
                            border="1px solid #b3b3b3"
                            value={value.id}
                            isChecked={value.compartilhado === "S"}
                            p={4}
                            onChange={async (e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              const isMarcado = value.compartilhado === "S";

                              if (isMarcado) {
                                const confirm = await Swal.fire({
                                  title: "Atenção!",
                                  text: "Caso o processo/procedimento seja descompartilhado, as informações serão excluídas somente da ficha descompartilhada. Deseja prosseguir?",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#169499",
                                  cancelButtonColor: "#169499",
                                  confirmButtonText: "Sim",
                                  cancelButtonText: "Não",
                                });

                                if (!confirm.isConfirmed) return;
                              }

                              toggleCheckbox(value.id, index, form);
                            }}
                            name={fieldNameCheck}
                          >
                            {value.nomeIrmao}
                          </Checkbox>
                        ))}
                      </>
                    )}
                  </Stack>
                </CheckboxGroup>
              )}
          </FormControl>
        )}
      </Field>
    </Flex>
  );
}
